(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tf-hero-slideshow')) {
    customElements.define('tf-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('.tf-hero__slide')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.pendingIndex = 0;
        this.sequence = 0;
        this.toggleIntent = undefined;
        this.touchStart = null;
        this.hovered = false;
        this.inView = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.interval = Math.max(5000, Number(this.dataset.interval) || 7000);
        this.toggle = this.querySelector('[data-toggle]');
        this.status = this.querySelector('[data-status]');
        this.media = this.querySelector('.tf-hero__media');
        this.slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === 0);
          slide.setAttribute('aria-hidden', String(index !== 0));
        });
        this.querySelector('[data-current]').textContent = '1';
        this.status.textContent = this.slides[0].getAttribute('aria-label');
        this.classList.add('is-ready');
        this.querySelector('[data-previous]').addEventListener('click', () => this.step(-1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.step(1), options);
        this.toggle.addEventListener('pointerdown', () => { this.toggleIntent = !this.paused; }, options);
        this.toggle.addEventListener('pointercancel', () => { this.toggleIntent = undefined; }, options);
        this.toggle.addEventListener('click', () => {
          const paused = this.toggleIntent === undefined ? !this.paused : this.toggleIntent;
          this.toggleIntent = undefined;
          this.setPaused(paused);
        }, options);
        this.addEventListener('focusin', () => this.setPaused(true), options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.schedule();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (!event.target.closest('.tf-hero__controls')) return;
          event.preventDefault();
          this.step(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.media.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          this.touchStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
          this.media.setPointerCapture(event.pointerId);
        }, options);
        this.media.addEventListener('pointerup', (event) => {
          if (!this.touchStart || event.pointerId !== this.touchStart.id) return;
          const x = event.clientX - this.touchStart.x;
          const y = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(x) > 40 && Math.abs(x) > Math.abs(y) * 1.2) this.step(x < 0 ? 1 : -1);
        }, options);
        this.media.addEventListener('pointercancel', () => { this.touchStart = null; }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.setPaused(true);
          this.updateControl();
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.setPaused(true);
          this.show(index);
        }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.schedule();
        }, { threshold: 0 });
        this.observer.observe(this);
        this.updateControl();
        const firstImage = this.slides[0].querySelector('img');
        if (!firstImage || firstImage.complete) this.prepare(1);
        else firstImage.addEventListener('load', () => this.prepare(1), { ...options, once: true });
        this.schedule();
      }
      disconnectedCallback() {
        this.initialized = false;
        this.sequence += 1;
        clearTimeout(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
      prepare(index) {
        const slide = this.slides[index];
        const template = slide.querySelector('template');
        if (template) {
          slide.append(template.content.cloneNode(true));
          template.remove();
        }
        const image = slide.querySelector('img');
        if (image) image.loading = 'eager';
        return image;
      }
      async show(index, direction = 1, attempts = 0) {
        clearTimeout(this.timer);
        const next = (index + this.slides.length) % this.slides.length;
        this.pendingIndex = next;
        const sequence = ++this.sequence;
        const signal = this.abort.signal;
        const image = this.prepare(next);
        if (image) {
          try { await image.decode(); } catch { }
        }
        if (!this.initialized || signal.aborted || sequence !== this.sequence) return;
        if (image && !image.naturalWidth) {
          if (attempts < this.slides.length - 1) return this.show(next + direction, direction, attempts + 1);
          this.pendingIndex = this.index;
          this.schedule();
          return;
        }
        this.slides.forEach((slide, position) => {
          slide.classList.toggle('is-active', position === next);
          slide.setAttribute('aria-hidden', String(position !== next));
        });
        this.index = next;
        this.querySelector('[data-current]').textContent = String(next + 1);
        this.status.textContent = this.slides[next].getAttribute('aria-label');
        this.prepare((next + 1) % this.slides.length);
        this.schedule();
      }
      step(direction) {
        this.setPaused(true);
        this.show(this.pendingIndex + direction, direction);
      }
      setPaused(paused) {
        if (paused && !this.paused) {
          this.sequence += 1;
          this.pendingIndex = this.index;
        }
        this.paused = paused;
        this.updateControl();
        this.schedule();
      }
      updateControl() {
        this.classList.toggle('is-paused', this.paused);
        const label = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.toggle.querySelector('[data-toggle-label]').textContent = label;
        this.toggle.hidden = this.motion.matches;
        this.status.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.initialized || this.paused || this.hovered || !this.inView || document.hidden || this.motion.matches) return;
        this.timer = setTimeout(() => this.show(this.pendingIndex + 1), this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
